import React, { useState } from 'react';
import { EmptyState } from '../common';
import api from '../../services/api';

const CATEGORY_LABELS = {
  technical_issue: 'Technical Issue',
  advertisement: 'Advertisement'
};

const STATUS_OPTIONS = ['new', 'read', 'resolved'];

const AdminContactMessagesTab = ({
  messages,
  loading,
  filters,
  setFilters,
  onSearch,
  onStatusChange
}) => {
  const [expandedRows, setExpandedRows] = useState(new Set());

  const toggleRow = (id) => {
    const newExpanded = new Set(expandedRows);
    if (newExpanded.has(id)) {
      newExpanded.delete(id);
    } else {
      newExpanded.add(id);
    }
    setExpandedRows(newExpanded);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case 'new': return 'status-badge pending';
      case 'read': return 'status-badge active';
      case 'resolved': return 'status-badge expired';
      default: return 'status-badge';
    }
  };

  const getCategoryBadgeClass = (category) => {
    return category === 'technical_issue'
      ? 'status-badge pending'
      : 'status-badge active';
  };

  const renderContent = () => {
    if (loading) {
      return <div className="loading">Loading...</div>;
    }

    if (messages.length === 0) {
      return (
        <EmptyState
          icon="✉️"
          title="No contact messages"
          message={filters.status || filters.category
            ? "No messages match your current filters."
            : "No contact messages have been submitted yet."}
        />
      );
    }

    return (
      <div className="admin-table-wrapper">
        <table className="admin-table">
          <thead>
            <tr>
              <th style={{ width: '40px' }}></th>
              <th>Date</th>
              <th>From</th>
              <th>Category</th>
              <th>Subject</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {messages.map(msg => (
              <React.Fragment key={msg.id}>
                <tr
                  onClick={() => toggleRow(msg.id)}
                  className={expandedRows.has(msg.id) ? 'expanded' : ''}
                  style={{ cursor: 'pointer' }}
                >
                  <td className="expand-cell">
                    <span className="expand-icon">
                      {expandedRows.has(msg.id) ? '▼' : '▶'}
                    </span>
                  </td>
                  <td>{formatDate(msg.created_at)}</td>
                  <td>
                    <div>{msg.user_name}</div>
                    <small className="text-muted">{msg.user_email}</small>
                  </td>
                  <td>
                    <span className={getCategoryBadgeClass(msg.category)}>
                      {CATEGORY_LABELS[msg.category] || msg.category}
                    </span>
                  </td>
                  <td>{msg.subject}</td>
                  <td>
                    <span className={getStatusBadgeClass(msg.status)}>
                      {msg.status}
                    </span>
                  </td>
                  <td>
                    <div className="actions" onClick={(e) => e.stopPropagation()}>
                      <select
                        value={msg.status}
                        onChange={(e) => onStatusChange(msg.id, e.target.value)}
                        className="bulk-status-select"
                      >
                        {STATUS_OPTIONS.map(s => (
                          <option key={s} value={s}>{s}</option>
                        ))}
                      </select>
                    </div>
                  </td>
                </tr>
                {expandedRows.has(msg.id) && (
                  <tr className="expanded-row">
                    <td colSpan="7">
                      <div className="audit-details">
                        <div className="audit-detail-section">
                          <h4>Message</h4>
                          <p style={{ whiteSpace: 'pre-wrap', fontSize: '0.9rem', color: 'var(--text-primary)' }}>
                            {msg.message}
                          </p>
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <>
      <div className="admin-actions-bar">
        <div className="admin-filters">
          <select
            value={filters.status || ''}
            onChange={(e) => setFilters({ ...filters, status: e.target.value })}
          >
            <option value="">All Statuses</option>
            <option value="new">New</option>
            <option value="read">Read</option>
            <option value="resolved">Resolved</option>
          </select>
          <select
            value={filters.category || ''}
            onChange={(e) => setFilters({ ...filters, category: e.target.value })}
          >
            <option value="">All Categories</option>
            <option value="technical_issue">Technical Issue</option>
            <option value="advertisement">Advertisement</option>
          </select>
          <button className="btn-search" onClick={onSearch}>
            Search
          </button>
        </div>
      </div>
      {renderContent()}
    </>
  );
};

export default AdminContactMessagesTab;
